import { render, staticRenderFns } from "./CreateService.vue?vue&type=template&id=4ebe7278&scoped=true&"
import script from "./CreateService.vue?vue&type=script&lang=js&"
export * from "./CreateService.vue?vue&type=script&lang=js&"
import style0 from "./CreateService.vue?vue&type=style&index=0&id=4ebe7278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebe7278",
  null
  
)

export default component.exports